import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet-async";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Counter from "yet-another-react-lightbox/plugins/counter";

import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";

export default function Yogaday() {

    const [open, setOpen] = useState(false);
    const [slides, setSlides] = useState([]);
    const [index, setIndex] = useState(0);
    
    const openGallery = (images, currentIndex) => {
        setSlides(images.map((img) => ({ src: img })));
        setIndex(currentIndex);
        setOpen(true);
    };

    const galleryMandela = [

    {
      title: "Nelson Mandela Day 2026",
      images: [
        "/img/gallery/nelsonmandela2026/1.png",
        "/img/gallery/nelsonmandela2026/2.png",
        "/img/gallery/nelsonmandela2026/3.png",
        "/img/gallery/nelsonmandela2026/4.png",
        "/img/gallery/nelsonmandela2026/5.png",
        "/img/gallery/nelsonmandela2026/6.png",
        "/img/gallery/nelsonmandela2026/7.png",
        "/img/gallery/nelsonmandela2026/8.png",
        "/img/gallery/nelsonmandela2026/9.png",
        "/img/gallery/nelsonmandela2026/10.png",
        "/img/gallery/nelsonmandela2026/11.png",
        "/img/gallery/nelsonmandela2026/13.png",
        "/img/gallery/nelsonmandela2026/14.png",
        "/img/gallery/nelsonmandela2026/15.png",
        "/img/gallery/nelsonmandela2026/16.png",
        "/img/gallery/nelsonmandela2026/17.png",
        "/img/gallery/nelsonmandela2026/18.png",
        "/img/gallery/nelsonmandela2026/19.png",
        "/img/gallery/nelsonmandela2026/20.png",
        "/img/gallery/nelsonmandela2026/21.png",
        "/img/gallery/nelsonmandela2026/22.png",
        "/img/gallery/nelsonmandela2026/23.png",
        "/img/gallery/nelsonmandela2026/24.png",
        "/img/gallery/nelsonmandela2026/25.png",
        "/img/gallery/nelsonmandela2026/26.png",
        "/img/gallery/nelsonmandela2026/12.png",
      ],
    },

    {
      title: "Nelson Mandela Day 2025",
      images: [
        "/img/gallery/nelsonmandela2025/1.jpg",
        "/img/gallery/nelsonmandela2025/2.jpg",
        "/img/gallery/nelsonmandela2025/3.jpg",
        "/img/gallery/nelsonmandela2025/4.jpg",
        "/img/gallery/nelsonmandela2025/5.jpg",
        "/img/gallery/nelsonmandela2025/6.jpg",
        "/img/gallery/nelsonmandela2025/7.jpg",
        "/img/gallery/nelsonmandela2025/8.jpg",
        "/img/gallery/nelsonmandela2025/9.jpg",
        "/img/gallery/nelsonmandela2025/10.jpg",
        "/img/gallery/nelsonmandela2025/11.jpg",
        "/img/gallery/nelsonmandela2025/12.jpg",
        "/img/gallery/nelsonmandela2025/13.jpg",
        "/img/gallery/nelsonmandela2025/14.jpg",
        "/img/gallery/nelsonmandela2025/15.jpg",
        "/img/gallery/nelsonmandela2025/16.jpg",
        "/img/gallery/nelsonmandela2025/17.jpg",
        "/img/gallery/nelsonmandela2025/18.jpg",
        "/img/gallery/nelsonmandela2025/19.jpg",
        "/img/gallery/nelsonmandela2025/20.jpg",
        "/img/gallery/nelsonmandela2025/21.jpg",
        "/img/gallery/nelsonmandela2025/22.jpg",
        "/img/gallery/nelsonmandela2025/23.jpg",
        "/img/gallery/nelsonmandela2025/24.jpg",
      ],
    },
   
    {
      title: "Nelson Mandela Day 2024",
      images: [
        "/img/gallery/nelsonmandeladay2024/1.jpg",
        "/img/gallery/nelsonmandeladay2024/2.jpg",
        "/img/gallery/nelsonmandeladay2024/3.jpg",
        "/img/gallery/nelsonmandeladay2024/4.jpg",
        "/img/gallery/nelsonmandeladay2024/5.jpg",
        "/img/gallery/nelsonmandeladay2024/6.jpg",
        "/img/gallery/nelsonmandeladay2024/7.jpg",
        "/img/gallery/nelsonmandeladay2024/8.jpg",
        "/img/gallery/nelsonmandeladay2024/9.jpg",
        "/img/gallery/nelsonmandeladay2024/10.jpg",
        "/img/gallery/nelsonmandeladay2024/11.jpg",
        "/img/gallery/nelsonmandeladay2024/12.jpg",
        "/img/gallery/nelsonmandeladay2024/13.jpg",
        "/img/gallery/nelsonmandeladay2024/14.jpg",
        "/img/gallery/nelsonmandeladay2024/15.jpg",
        "/img/gallery/nelsonmandeladay2024/16.jpg",
        "/img/gallery/nelsonmandeladay2024/17.jpg",
        "/img/gallery/nelsonmandeladay2024/18.jpg",
        "/img/gallery/nelsonmandeladay2024/19.jpg",
      ],
    },
    {
      title: "Nelson Mandela Day 2022",
      images: [
        "/img/gallery/nelsonmandela2022/1.jpg",
        "/img/gallery/nelsonmandela2022/2.jpg",
        "/img/gallery/nelsonmandela2022/3.jpg",
        "/img/gallery/nelsonmandela2022/4.jpg",
        "/img/gallery/nelsonmandela2022/5.jpg",
        "/img/gallery/nelsonmandela2022/6.jpg",
        "/img/gallery/nelsonmandela2022/7.jpg",
        "/img/gallery/nelsonmandela2022/8.jpg",
        "/img/gallery/nelsonmandela2022/9.jpg",
        "/img/gallery/nelsonmandela2022/10.jpg",
        "/img/gallery/nelsonmandela2022/11.jpg",
        "/img/gallery/nelsonmandela2022/12.jpg",
        "/img/gallery/nelsonmandela2022/13.jpg",
        "/img/gallery/nelsonmandela2022/14.jpg",
        "/img/gallery/nelsonmandela2022/15.jpg",
        "/img/gallery/nelsonmandela2022/16.jpg",
      ],
    },
];

  return (
    <>
      <Helmet>
        <title>Nelson Mandela Day | Gandhi Mandela Foundation</title>
      </Helmet>

      <Header />
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb">
            <a href="/">Home</a>
            <span>/</span>
            <span>Nelson Mandela Day</span>
          </div>

          <h1>Nelson Mandela Day</h1>
        </div>
      </section>
        
      <section className="gallery-section">
        <div className="container">
        
          {galleryMandela.map((section, sectionIndex) => (
            <div className="gallery-block" key={sectionIndex}>

              <h2 className="gallery-title">
                {section.title}
              </h2>
                {/* Sirf Yoga Day section me banner dikhega */}
                    {section.title === "Nelson Mandela Day" && (
                    <div
                        className="full-image-wrapper"
                        onClick={() =>
                            openGallery(
                            ["/img/gallery/GMF/1.jpg", ...section.images],
                            0
                            )
                        }
                        >
                        <img
                            src="/img/gallery/GMF/1.jpg"
                            alt="Nobel Prize winner Rigoberta Menchú Tum conferred with Gandhi Mandela Award 2020"
                            className="full-width-image"
                        />
                        <h4 align="center">
                            Nobel Prize winner Rigoberta Menchú Tum conferred with Gandhi Mandela Award 2020
                        </h4>
                    </div>
                    )}
              <div className="gallery-grid">

                {section.images.map((image, imageIndex) => (
                  <div
                    key={imageIndex}
                    className="gallery-card"
                    onClick={() =>
                      openGallery(section.images, imageIndex)
                    }
                  >
                    <img
                      src={image}
                      alt={`${section.title} ${imageIndex + 1}`}
                    />
                  </div>
                ))}

              </div>

            </div>
          ))}

        </div>
      </section>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}
        plugins={[Zoom, Thumbnails, Counter]}
      />
      <Footer />
    </>
  );
}
